import React, { ReactElement } from 'react';

import CommonSelectInputWrapper from '../../../common/CommonSelectInputWrapper';
import { getEnvironmentalInformationSelectInputProps } from '../../../common/EnvironmentalInformationSelectInputProps';
import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import { debounce } from 'lodash-es';
import { risksActions } from '../../../../behavior/risks';
import { connect } from 'react-redux';

type Props = {
  values: any;
  initialData: any;
  filter: any | null;
  disabled: any;
  envRiskCalculation: () => void;
  setFieldValue: (arg1: string, arg2: string | null) => void;
};

const IEnvironmentalInformationAllSelectInputs = ({
  values,
  initialData,
  filter,
  disabled,
  envRiskCalculation,
  setFieldValue,
}: Props) => {
  const debouncedEnvRiskCalculation = debounce(envRiskCalculation, 2000);

  const environmentalInformationSelectInputProps = getEnvironmentalInformationSelectInputProps(
    initialData.riskList,
    initialData.riskWatershedList,
    values.envAttributes,
    filter
  );
  const environmentalInformationSelectInputsComponent: ReactElement[] = [];
  const envAttributesPropName = 'envAttributes';
  if (!values[envAttributesPropName]) {
    values[envAttributesPropName] = {};
  }

  environmentalInformationSelectInputProps.forEach(i => {
    if (!values[envAttributesPropName][i.propertyName]) {
      values[envAttributesPropName][i.propertyName] = {};
    }

    environmentalInformationSelectInputsComponent.push(
      <GridColumnInputWrapper
        key={i.propertyName}
        name={envAttributesPropName + '.' + i.propertyName + '.id'}
        label={i.label}
        specialRequiredCondition={true}
        disabled={disabled || i.disabled}
        setFieldValue={setFieldValue}
        values={values}
        render={(props: any) => (
          <CommonSelectInputWrapper
            options={i.options}
            value={values[envAttributesPropName][i.propertyName]['id'] || ''}
            placeholder="select.input.default.placeholder"
            onChange={debouncedEnvRiskCalculation}
            propUsedInChanges={i.propUsedInChanges}
            {...props}
          />
        )}
      />
    );
  });
  return <>{environmentalInformationSelectInputsComponent}</>;
};

const mapDispatchToProps = (dispatch: any) => ({
  envRiskCalculation: () => dispatch(risksActions.envRiskCalculation()),
});

IEnvironmentalInformationAllSelectInputs.defaultProps = {
  filter: null,
};

export default connect(null, mapDispatchToProps)(IEnvironmentalInformationAllSelectInputs);
